import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-shrink-0 w-full max-w-[260px]">
            <div className="relative rounded-2xl overflow-hidden bg-background-200">
              <img
                src={appData.image}
                alt={appData.alt}
                className="w-full h-auto object-cover"
                loading="lazy"
                onError={(e) => { e.currentTarget.parentElement!.style.display = 'none'; }}
              />
            </div>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-semibold text-accent-700 bg-accent-100/80 rounded-full mb-4">
              随时随地浏览
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">{appData.title}</h2>
            <p className="text-lg text-foreground-600 mt-1">{appData.subtitle}</p>
            <p className="mt-4 text-sm text-foreground-700 leading-relaxed max-w-[560px] mx-auto lg:mx-0">
              {appData.description}
            </p>
            <div className="flex flex-wrap justify-center lg:justify-start gap-3 mt-6">
              {appData.features.map((feat) => (
                <span key={feat} className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-secondary-700 bg-secondary-100 rounded-lg">
                  <i className="ri-check-line text-sm"></i>
                  {feat}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}